/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading,
  NavLink,
  SvgIcon
} from "../"

export class Card extends React.Component {
  state = {
    bodyExpanded: this.props.bodyExpanded
  }

  toggleBody = () => this.setState(prevState => ({ bodyExpanded: !prevState.bodyExpanded }))

  render() {
    const { title, titleLink, subtitle, info, icon, body, footer, yScrollable, paddingTRL, allowHideAndExpand, className, style, onClick } = this.props

    return (
      <article className={`slds-card ${className} ${onClick ? 'clickable card-hover' : ''}`} style={style} onClick={onClick}>
        {title &&
          <div
            className="slds-card__header slds-p-left_large slds-p-right_large slds-p-top_medium slds-p-bottom_medium u-bg-color-white__alpha"
            onClick={allowHideAndExpand ? this.toggleBody : () => false}
            style={{ borderRadius: 'inherit' }}>
            <header className="slds-media slds-media_center slds-has-flexi-truncate">
              {icon &&
                <div className="slds-media__figure">
                  {icon}
                </div>
              }
              <div className="slds-media__body">
                <Heading marginBottom={subtitle ? 2 : 0}>
                  {titleLink
                    ? <NavLink to={titleLink}>
                        <b>{title}</b>
                      </NavLink>
                    : <span className="u-text-caps card__title" style={{ letterSpacing: '1px' }}>
                        {title}
                      </span>
                  }
                </Heading>
                {subtitle &&
                  <div className='u-font-size-larger'>
                    {subtitle}
                  </div>
                }
              </div>
              {allowHideAndExpand
                ? <SvgIcon
                    variant='utility'
                    symbol={this.state.bodyExpanded ? 'chevronup' : 'chevrondown'}
                    size='x-small'
                  />
                : info &&
                  <div>
                    {info}
                  </div>
              }
            </header>
          </div>
        }
        <div className={`${this.state.bodyExpanded ? '' : 'slds-hide'}`} style={{ borderRadius: 'inherit' }}>
          <div className={`slds-card__body slds-p-top_medium slds-p-bottom_medium slds-p-left_x-large slds-p-right_x-large u-bg-color-white u-no-margin__b${yScrollable ? " slds-scrollable_y" : ''}${paddingTRL ? " slds-p-left_x-large slds-p-right_x-large slds-p-top_medium u-no-padding_b" : ''}`}>
            {body}
          </div>
          {footer &&
            <footer className="card__footer u-bg-color-white">
              {footer}
            </footer>
          }
        </div>
      </article>
    )
  }
}

Card.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  titleLink: PropTypes.string,
  icon: PropTypes.element,  // SvgIcon
  info: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  body: PropTypes.any.isRequired,
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  yScrollable: PropTypes.bool,
  paddingTRL: PropTypes.bool,
  allowHideAndExpand: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

Card.defaultProps = {
  className: '',
  bodyExpanded: true
}



// WEBPACK FOOTER //
// ./src/components/card/index.js